import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = null as null | GiftcardSurcharge;

const slice = createSlice({
  name: '$giftcardSurcharge',
  initialState,
  reducers: {
    setGiftcardSurcharge(
      state,
      action: PayloadAction<GiftcardSurcharge | null>,
    ) {
      return action.payload;
    },
  },
});

export const { setGiftcardSurcharge } = slice.actions;

export default slice.reducer;
